import { useState } from 'react'

import { DEFAULT_PAGINATION } from '@app/constants/pagination'

import type { PaginationHookReturn, Pagination } from '@app/types/pagination'

export const usePagination = (): PaginationHookReturn => {
  const [pagination, setPagination] = useState<Pagination>(DEFAULT_PAGINATION)

  const handlePaginationCurrentPageReset = (): void =>
    setPagination(prevPagination => ({
      ...prevPagination,
      current: DEFAULT_PAGINATION.current
    }))

  return {
    pagination,
    setPagination,
    resetCurrentPage: handlePaginationCurrentPageReset
  }
}
